import { render } from "./ProcessoParteCadastrar.vue?vue&type=template&id=1eef33d2&scoped=true"
import script from "./ProcessoParteCadastrar.vue?vue&type=script&lang=js"
export * from "./ProcessoParteCadastrar.vue?vue&type=script&lang=js"

import "./ProcessoParteCadastrar.vue?vue&type=style&index=0&id=1eef33d2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eef33d2"]])

export default __exports__